import styled from "styled-components";
import { colors } from "../colors";

export const HeadingText = styled.h2`
color: ${colors.white}
margin-bottom: 0;
margin-top: -1rem;
`;